/* eslint-disable @typescript-eslint/naming-convention */
import { Route } from 'react-router-dom'
import { DashboardPage } from 'pages/Dashboard/DashboardPage'
import { PromotionsPage } from 'pages/Promotions/PromotionsPage'
import { MessagesPage } from 'pages/Communications/Messages/MessagesPage'
import { BannersPage } from 'pages/Communications/Banners/BannersPage'
import { RewardItemsPage } from 'pages/RewardItems/RewardItemsPage'
import { PatronAccountsPage } from 'pages/Patrons/PatronAccountsPage'
import { PromotionsNewPage } from 'pages/Promotions/PromotionsNewPage'
import { RewardItemsNewPage } from 'pages/RewardItems/RewardItemsNewPage'
import { SweepstakesPage } from 'pages/Contests/Sweeptakes/SweepstakesPage'
import { RewardCatalogsPage } from 'pages/RewardCatalogs/RewardCatalogsPage'
import { RewardsProgramPage } from 'pages/RewardsPrograms/RewardsProgramPage'
import { RewardItemsDetailPage } from 'pages/RewardItems/RewardItemsDetailPage'
import { SweepstakesNewPage } from 'pages/Contests/Sweeptakes/SweepstakesNewPage'
import { RewardCatalogsNewPage } from 'pages/RewardCatalogs/RewardCatalogsNewPage'
import { PassportGamesPage } from 'pages/Contests/PassportGames/PassportGamesPage'
import { JJUpdatesPage } from 'pages/JJUpdates/JJUpdatesPage'
import { OrganizationList } from 'pages/ClientManagement/Organization/OrganizationList'
import { LEConnectUsersPage } from 'pages/ClientManagement/LEConnectUsers/LEConnectUsersPage'
import { PromotionDetailsPage } from 'pages/Promotions/PromotionDetailsPage/PromotionDetailsPage'
import { PatronOverviewPage } from 'pages/Patrons/PatronAccountDetails/Overview/PatronOverviewPage'
import { PatronNotesList } from 'pages/Patrons/PatronAccountDetails/Notes/PatronNotesList'
import { CorporateAccountList } from 'pages/ClientManagement/CorporateAccounts/CorporateAccountList'
import { CommunicationsSystemBannerNewPage } from 'pages/Communications/CommunicationsNew/SystemBanner/CommunicationsSystemBannerNewPage'
import { NewLEConnectUserPage } from 'pages/ClientManagement/LEConnectUsersPage/NewLEConnectUserPage'
import { LEConnectUserDetailsPage } from 'pages/ClientManagement/LEConnectUsersPage/LEConnectUserDetailsPage'
import { RewardProgramDetailPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/RewardProgramDetailPage'
import { PatronPointBalancePage } from 'pages/Patrons/PatronAccountDetails/PointBalance/PatronPointBalancePage'
import { RewardsCatalogsDetailPage } from 'pages/RewardCatalogs/RewardCatalogsDetails/RewardCatalogsDetailPage'
import { SweepstakeOverviewPage } from 'pages/Contests/Sweeptakes/SweepstakesDetailsPage/SweepstakeOverviewPage'
import { OrganizationsNewPage } from 'pages/ClientManagement/Organization/OrganizationNewPage/OrganizationsNewPage'
import { PatronCheckInHistoryPage } from 'pages/Patrons/PatronAccountDetails/CheckInHistory/PatronCheckInHistoryPage'
import { RewardProgramSettingsPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/Settings/RewardProgramSettingsPage'
import { LicensedEstablishmentListPage } from 'pages/ClientManagement/LicensedEstablishments/LicensedEstablishmentListPage'
import { OrganizationsDetailPage } from 'pages/ClientManagement/Organization/OrganizationDetailsPage/OrganizationsDetailPage'
import { PatronActivityLogPage } from 'pages/Patrons/PatronAccountDetails/ActivityLog/PatronActivityLogPage'
import { RewardProgramSendRewardPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/SendReward/RewardProgramSendRewardPage'
import { ManageCatalogRewardsPage } from 'pages/RewardCatalogs/RewardCatalogsDetails/ManageCatalogRewards/ManageCatalogRewardsPage'
import { CorporateAccountsNewPage } from 'pages/ClientManagement/CorporateAccounts/CorporateAccountNewPage/CorporateAccountsNewPage'
import { RewardProgramRedemptionsPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/Redemptions/RewardProgramRedemptionsPage'
import { SweepstakeParticipatingLocationsPage } from 'pages/Contests/Sweeptakes/SweepstakesDetailsPage/SweepstakeParticipatingLocationsPage'
import { SweepstakeActivityLogPage } from 'pages/Contests/Sweeptakes/SweepstakeActivityLog/SweepstakeActivityLogPage'
import { CorporateAccountsDetailPage } from 'pages/ClientManagement/CorporateAccounts/CorporateAccountDetailsPage/CorporateAccountsDetailPage'
import { ManageEnrollLocationsPage } from 'pages/Contests/Sweeptakes/SweepstakesEnrollLocations/ManageEnrollLocationsPage'
import { LicensedEstablishmentNewPage } from 'pages/ClientManagement/LicensedEstablishments/LicensedEstablishmentNewPage/LicensedEstablishmentNewPage'
import { RewardProgramTransactionHistoryPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/TransactionHistory/RewardProgramTransactionHistoryPage'
import { LicensedEstablishmentDetailsPage } from 'pages/ClientManagement/LicensedEstablishments/LicensedEstablishmentDetailsPage/LicensedEstablishmentDetailsPage'
import { LicensedEstablishmentAssignOrganizationPage } from 'pages/ClientManagement/LicensedEstablishments/AssignOrganization/LicensedEstablishmentAssignOrganizationPage'
import { LicensedEstablishmentDetailsRewardsProgramPage } from 'pages/ClientManagement/LicensedEstablishments/LicensedEstablishmentDetailsPage/LicensedEstablishmentDetailsRewardsProgramPage'
import { PassportGameNewPage } from 'pages/Contests/PassportGames/PassportGameNewPage'
import { SweepstakesWinnersPage } from 'pages/Contests/Sweeptakes/SweepstakesWinnersPage/SweepstakesWinnersPage'
import { CorporateAccountAssociatedAccountsPage } from 'pages/ClientManagement/CorporateAccounts/CorporateAccountDetailsPage/CorporateAccountAssociatedAccountsPage/CorporateAccountAssociatedAccountsPage'
import { CorporateAccountJJConnectUsersPage } from 'pages/ClientManagement/CorporateAccounts/CorporateAccountDetailsPage/CorporateAccountJJConnectUsersPage/CorporateAccountJJConnectUsersPage'
import { SweepstakesAdditionalEnrollmentDetailsPage } from 'pages/Contests/Sweeptakes/SweepstakesAdditionalEnrollmentDetails/SweepstakesAdditionalEnrollmentDetailsPage'
import { SweepstakesReviewEnrollmentPage } from 'pages/Contests/Sweeptakes/SweepstakesReviewEnrollment/SweepstakesReviewEnrollmentPage'
import { CommunicationsMessageNewPage } from 'pages/Communications/CommunicationsNew/Message/CommunicationsMessageNewPage'
import { SweepstakeDetailsSettingsPage } from 'pages/Contests/Sweeptakes/SweepstakesDetailsPage/SweepstakeDetailsSettingsPage'
import { WinnerDetailsPage } from 'pages/Contests/Sweeptakes/SweepstakesWinnerDetailsPage/WinnerDetailsPage'
import { SweepstakeLocationDetailPage } from 'pages/Contests/Sweeptakes/SweepstakeLocationDetailPage/SweepstakeLocationDetailPage'
import { CommunicationDetailsPage } from 'pages/Communications/Messages/MessageDetailPage/CommunicationDetailsPage'
import { RewardProgramBalancesPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/Balances/RewardProgramBalancesPage'
import { LicensedEstablishmentDetailsSpecialsEventsPage } from 'pages/ClientManagement/LicensedEstablishments/LicensedEstablishmentDetailsPage/LicensedEstablishmentDetailsSpecialsEvents/LicensedEstablishmentDetailsSpecialsEventsPage'
import { CorporateAccountSpecialsEventsPage } from 'pages/ClientManagement/CorporateAccounts/CorporateAccountDetailsPage/CorporateAccountSpecialsEvents/CorporateAccountSpecialsEventsPage'
import { OrganizationSpecialsEventsPage } from 'pages/ClientManagement/Organization/OrganizationDetailsPage/OrganizationSpecialsEvents/OrganizationSpecialsEventsPage'
import { NewslettersNewPage } from 'pages/JJUpdates/Newsletters/NewslettersNewPage'
import { NewslettersDetailsPage } from 'pages/JJUpdates/Newsletters/NewslettersDetailsPage'
import { SettingsDetailsPageEULA } from 'pages/Settings/SettingsDetailsPageEULA'
import { SettingsDetailsPatronApp } from 'pages/Settings/SettingsDetailsPagePatronApp'
import { BannerDetailsPage } from 'pages/Communications/Banners/BannerDetailsPage'
import { LocationSweepstakesPage } from 'pages/Contests/LocationSweepstakes/LocationSweepstakesPage'
import { LocationSweepstakesNewPage } from 'pages/Contests/LocationSweepstakes/LocationSweepstakesNewPage'
import { LocationSweepstakeOverviewPage } from 'pages/Contests/LocationSweepstakes/LocationSweepstakesDetailsPage/LocationSweepstakeOverviewPage'
import { LocationSweepstakeParticipatingLocationsPage } from 'pages/Contests/LocationSweepstakes/LocationSweepstakesDetailsPage/LocationSweepstakeParticipatingLocationsPage'
import { LocationSweepstakeDetailsSettingsPage } from 'pages/Contests/LocationSweepstakes/LocationSweepstakesDetailsPage/LocationSweepstakeDetailsSettingsPage'
import { LocationSweepstakesWinnersPage } from 'pages/Contests/LocationSweepstakes/LocationSweepstakesWinnersPage/LocationSweepstakesWinnersPage'
import { SettingsDetailsCelebrations } from 'pages/Settings/SettingsDetailsCelebrations'
import { States, useCurrentStateStore } from 'stores/useCurrentStateStore'
import { featureAccessStore } from 'stores/featureAccessStore'
import { JJBadgesPage } from 'pages/Contests/Badges/JJBadges/JJBadgesPage'
import { JJBadgesNewPage } from 'pages/Contests/Badges/JJBadges/JJBadgesNewPage'
import { JJBadgesDetailPage } from 'pages/Contests/Badges/JJBadges/JJBadgesDetailPage'
import { RewardProgramActivityLogPage } from 'pages/RewardsPrograms/RewardsProgramsDetails/ActivityLog/RewardProgramActivityLog'
import { type groupPermissionStore } from 'stores/groupPermissionStore'
import { PatronBadgesPage } from 'pages/Patrons/PatronAccountDetails/Badges/PatronBadgesPage'
import { JJResourcesPage } from 'pages/JJUpdates/Resources/JJResourcesPage'
import { ResourcesNewPage } from 'pages/JJUpdates/Resources/ResourcesNewPage'
import { ResourcesDetailsPage } from 'pages/JJUpdates/Resources/ResourcesDetailsPage'
import { PatronSweepstakesPage } from 'pages/Patrons/PatronAccountDetails/Sweepstakes/PatronSweepstakes'
import { LocationBadgesPage } from 'pages/Contests/Badges/LocationBadges/LocationBadgesPage'
import { LocationBadgesNewPage } from 'pages/Contests/Badges/LocationBadges/LocationBadgesNewPage'
import { LocationBadgesDetailPage } from 'pages/Contests/Badges/LocationBadges/LocationBadgesDetailPage'

type GroupPermissionState = ReturnType<typeof groupPermissionStore.getState>

export const getProtectedRoutes = (permissions: GroupPermissionState) => {
  const { currentStateName } = useCurrentStateStore.getState()
  const routeAllowed = currentStateName === States.ILLINOIS

  const specialsAndEventsFeatureAllowed =
    featureAccessStore.getState().specialsAndEvents
  const communicationsBannerMessagesFeatureAllowed =
    featureAccessStore.getState().communicationsBannerMessages
  const communicationsPushNotificationsFeatureAllowed =
    featureAccessStore.getState().communicationsPushNotifications

  const permissionsLoaded = permissions.permissionsLoaded
  const clientManagementPermission = permissions.clientManagementPermission
  const clientManagement_LicensedEstablishmentsPermission =
    permissions.clientManagement_LicensedEstablishmentsPermission
  const clientManagement_OrganizationsPermission =
    permissions.clientManagement_OrganizationsPermission
  const clientManagement_CorporateAccountsPermission =
    permissions.clientManagement_CorporateAccountsPermission
  const clientManagement_LEConnectUsersPermission =
    permissions.clientManagement_LEConnectUsersPermission
  const patronAccountsPermission = permissions.patronAccountsPermission
  const rewardsPermission = permissions.rewardsPermission
  const rewards_RewardProgramsPermission =
    permissions.rewards_RewardProgramsPermission
  const rewards_RewardCatalogsPermission =
    permissions.rewards_RewardCatalogsPermission
  const rewards_RewardItemsPermission =
    permissions.rewards_RewardItemsPermission
  const promotionsPermission = permissions.promotionsPermission
  const contestsPermission = permissions.contestsPermission
  const contests_SweepstakesPermission =
    permissions.contests_SweepstakesPermission
  const contests_LocationSweepstakesPermission =
    permissions.contests_LocationSweepstakesPermission
  const contests_PassportGamesPermission =
    permissions.contests_PassportGamesPermission
  const communicationsPermission = permissions.communicationsPermission
  const communications_MessagesPermission =
    permissions.communications_MessagesPermission
  const communications_BannersPermission =
    permissions.communications_BannersPermission
  const jjUpdatesPermission = permissions.jjUpdatesPermission
  const settingsPermission = permissions.settingsPermission
  const contests_BadgeRewardsPermission =
    permissions.contests_BadgeRewardsPermission
  const contests_LocationsBadgeRewardsPermission =
    permissions.contests_LocationsBadgeRewardsPermission

  if (!permissionsLoaded) {
    return [<Route path="/Home" key="/Home" element={<DashboardPage />} />]
  }

  const routesProtected = [
    { path: '/Home', element: <DashboardPage /> },

    ...(clientManagementPermission
      ? [
          ...(clientManagement_LicensedEstablishmentsPermission
            ? [
                {
                  path: '/ClientManagement/LicensedEstablishments',
                  element: <LicensedEstablishmentListPage />,
                },
                {
                  path: '/ClientManagement/LicensedEstablishments/New',
                  element: <LicensedEstablishmentNewPage />,
                },
                {
                  path: '/LicensedEstablishment/New',
                  element: <LicensedEstablishmentNewPage />,
                },
                {
                  path: '/ClientManagement/LicensedEstablishments/:id',
                  element: <LicensedEstablishmentDetailsPage />,
                },
                {
                  path: '/LicensedEstablishments/:id',
                  element: <LicensedEstablishmentDetailsPage />,
                },
                ...(routeAllowed
                  ? [
                      {
                        path: '/ClientManagement/LicensedEstablishments/:id/RewardsProgram',
                        element: (
                          <LicensedEstablishmentDetailsRewardsProgramPage />
                        ),
                      },
                      {
                        path: '/LicensedEstablishments/:id/RewardsProgram',
                        element: (
                          <LicensedEstablishmentDetailsRewardsProgramPage />
                        ),
                      },
                    ]
                  : []),
                ...(specialsAndEventsFeatureAllowed
                  ? [
                      {
                        path: '/ClientManagement/LicensedEstablishments/:id/LicensedEstablishmentDetailsSpecialsEvents',
                        element: (
                          <LicensedEstablishmentDetailsSpecialsEventsPage />
                        ),
                      },
                      {
                        path: '/LicensedEstablishments/:id/LicensedEstablishmentDetailsSpecialsEvents',
                        element: (
                          <LicensedEstablishmentDetailsSpecialsEventsPage />
                        ),
                      },
                    ]
                  : []),
                {
                  path: '/ClientManagement/LicensedEstablishments/:id/AssignOrganization',
                  element: <LicensedEstablishmentAssignOrganizationPage />,
                },
                {
                  path: '/LicensedEstablishments/:id/AssignOrganization',
                  element: <LicensedEstablishmentAssignOrganizationPage />,
                },
              ]
            : []),
          ...(clientManagement_OrganizationsPermission
            ? [
                {
                  path: '/ClientManagement/Organizations',
                  element: <OrganizationList />,
                },
                {
                  path: '/ClientManagement/Organizations/New',
                  element: <OrganizationsNewPage />,
                },
                {
                  path: '/Organizations/New',
                  element: <OrganizationsNewPage />,
                },
                {
                  path: '/ClientManagement/Organizations/:id',
                  element: <OrganizationsDetailPage />,
                },
                {
                  path: '/Organization/:id',
                  element: <OrganizationsDetailPage />,
                },
                {
                  path: '/ClientManagement/Organizations/:id/OrganizationSpecialsEvents',
                  element: <OrganizationSpecialsEventsPage />,
                },
                {
                  path: '/Organization/:id/OrganizationSpecialsEvents',
                  element: <OrganizationSpecialsEventsPage />,
                },
              ]
            : []),
          ...(clientManagement_CorporateAccountsPermission
            ? [
                {
                  path: '/ClientManagement/CorporateAccounts',
                  element: <CorporateAccountList />,
                },
                {
                  path: '/ClientManagement/CorporateAccounts/:id/:tab',
                  element: <CorporateAccountsDetailPage />,
                },
                {
                  path: '/CorporateAccounts/:id/:tab',
                  element: <CorporateAccountsDetailPage />,
                },
                {
                  path: '/ClientManagement/CorporateAccounts/New',
                  element: <CorporateAccountsNewPage />,
                },
                {
                  path: '/CorporateAccounts/New',
                  element: <CorporateAccountsNewPage />,
                },
                {
                  path: '/ClientManagement/CorporateAccounts/:id/CorporateAccountAssociatedAccounts',
                  element: <CorporateAccountAssociatedAccountsPage />,
                },
                {
                  path: '/CorporateAccounts/:id/CorporateAccountAssociatedAccounts',
                  element: <CorporateAccountAssociatedAccountsPage />,
                },
                {
                  path: '/ClientManagement/CorporateAccounts/:id/CorporateAccountLEUsers',
                  element: <CorporateAccountJJConnectUsersPage />,
                },
                {
                  path: '/CorporateAccounts/:id/CorporateAccountLEUsers',
                  element: <CorporateAccountJJConnectUsersPage />,
                },
                ...(specialsAndEventsFeatureAllowed
                  ? [
                      {
                        path: '/ClientManagement/CorporateAccounts/:id/CorporateAccountSpecialsEvents',
                        element: <CorporateAccountSpecialsEventsPage />,
                      },
                      {
                        path: '/CorporateAccounts/:id/CorporateAccountSpecialsEvents',
                        element: <CorporateAccountSpecialsEventsPage />,
                      },
                    ]
                  : []),
              ]
            : []),
          ...(clientManagement_LEConnectUsersPermission
            ? [
                {
                  path: '/ClientManagement/LEConnectUsers',
                  element: <LEConnectUsersPage />,
                },
                {
                  path: '/ClientManagement/LEConnectUsers/New',
                  element: <NewLEConnectUserPage />,
                },
                {
                  path: '/ClientManagement/LEConnectUsers/:id',
                  element: <LEConnectUserDetailsPage />,
                },
              ]
            : []),
        ]
      : []),

    ...(patronAccountsPermission
      ? [
          {
            path: '/PatronAccounts',
            element: <PatronAccountsPage />,
          },
          {
            path: '/PatronAccounts/:id/Overview',
            element: <PatronOverviewPage />,
          },
          ...(routeAllowed
            ? [
                {
                  path: '/PatronAccounts/:id/CheckInHistory',
                  element: <PatronCheckInHistoryPage />,
                },
              ]
            : []),
          ...(routeAllowed
            ? [
                {
                  path: '/PatronAccounts/:id/ActivityLog',
                  element: <PatronActivityLogPage />,
                },
              ]
            : []),
          ...(routeAllowed
            ? [
                {
                  path: '/PatronAccounts/:id/PointBalance',
                  element: <PatronPointBalancePage />,
                },
              ]
            : []),
          ...(routeAllowed
            ? [
                {
                  path: '/PatronAccounts/:id/Sweepstakes',
                  element: <PatronSweepstakesPage />,
                },
              ]
            : []),

          {
            path: '/PatronAccounts/:id/Badges',
            element: <PatronBadgesPage />,
          },
          {
            path: '/PatronAccounts/:id/Notes',
            element: <PatronNotesList />,
          },
        ]
      : []),

    ...(rewardsPermission && routeAllowed
      ? [
          ...(rewards_RewardProgramsPermission
            ? [
                {
                  path: '/Rewards/RewardPrograms',
                  element: <RewardsProgramPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id',
                  element: <RewardProgramDetailPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id/Balances',
                  element: <RewardProgramBalancesPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id/SendReward',
                  element: <RewardProgramSendRewardPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id/Settings',
                  element: <RewardProgramSettingsPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id/TransactionHistory',
                  element: <RewardProgramTransactionHistoryPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id/Redemption',
                  element: <RewardProgramRedemptionsPage />,
                },
                {
                  path: '/Rewards/RewardPrograms/:id/ActivityLog',
                  element: <RewardProgramActivityLogPage />,
                },
              ]
            : []),
          ...(rewards_RewardItemsPermission
            ? [
                {
                  path: '/Rewards/RewardItems',
                  element: <RewardItemsPage />,
                },
                {
                  path: '/Rewards/RewardItems/:id',
                  element: <RewardItemsDetailPage />,
                },
                {
                  path: '/Rewards/RewardItems/New',
                  element: <RewardItemsNewPage />,
                },
              ]
            : []),
          ...(rewards_RewardCatalogsPermission
            ? [
                {
                  path: '/Rewards/RewardCatalogs',
                  element: <RewardCatalogsPage />,
                },
                {
                  path: '/Rewards/RewardCatalogs/:id',
                  element: <RewardsCatalogsDetailPage />,
                },
                {
                  path: '/Rewards/RewardCatalogs/:id/ManageCatalogRewards',
                  element: <ManageCatalogRewardsPage />,
                },
                {
                  path: '/Rewards/RewardCatalogs/New',
                  element: <RewardCatalogsNewPage />,
                },
              ]
            : []),
        ]
      : []),

    ...(contestsPermission && routeAllowed
      ? [
          ...(contests_SweepstakesPermission
            ? [
                {
                  path: '/Contests/Sweepstakes',
                  element: <SweepstakesPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/Overview',
                  element: <SweepstakeOverviewPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/Settings',
                  element: <SweepstakeDetailsSettingsPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/ParticipatingLocations',
                  element: <SweepstakeParticipatingLocationsPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/Manage-participating-locations',
                  element: <ManageEnrollLocationsPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/AdditionalEnrollmentDetails',
                  element: <SweepstakesAdditionalEnrollmentDetailsPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/ReviewEnrollment',
                  element: <SweepstakesReviewEnrollmentPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/AdditionalEnrollmentDetails',
                  element: <SweepstakesAdditionalEnrollmentDetailsPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/ReviewEnrollment',
                  element: <SweepstakesReviewEnrollmentPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/AdditionalEnrollmentDetails',
                  element: <SweepstakesAdditionalEnrollmentDetailsPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/ReviewEnrollment',
                  element: <SweepstakesReviewEnrollmentPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:contestId/LicensedEstablishment/:licensedEstablishmentId/ViewLocationEnrollment',
                  element: <SweepstakeLocationDetailPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/ActivityLog',
                  element: <SweepstakeActivityLogPage />,
                },
                {
                  path: '/Contests/Sweepstakes/:id/Winners',
                  element: <SweepstakesWinnersPage />,
                },
                {
                  path: '/Contests/Sweepstakes/New',
                  element: <SweepstakesNewPage />,
                },
              ]
            : []),
          ...(contests_LocationSweepstakesPermission
            ? [
                {
                  path: '/Contests/LocationSweepstakes',
                  element: <LocationSweepstakesPage />,
                },
                {
                  path: '/Contests/LocationSweepstakes/:id/Overview',
                  element: <LocationSweepstakeOverviewPage />,
                },
                {
                  path: '/Contests/LocationSweepstakes/New',
                  element: <LocationSweepstakesNewPage />,
                },
                {
                  path: '/Contests/LocationSweepstakes/:id/Settings',
                  element: <LocationSweepstakeDetailsSettingsPage />,
                },
                {
                  path: '/Contests/LocationSweepstakes/:id/ParticipatingLocations',
                  element: <LocationSweepstakeParticipatingLocationsPage />,
                },
                {
                  path: '/Contests/LocationSweepstakes/:id/Winners',
                  element: <LocationSweepstakesWinnersPage />,
                },
              ]
            : []),
          ...(contests_PassportGamesPermission
            ? [
                {
                  path: '/Contests/PassportGames',
                  element: <PassportGamesPage />,
                },
                {
                  path: '/Contests/PassportGames/New',
                  element: <PassportGameNewPage />,
                },
                {
                  path: '/Winners/:id',
                  element: <WinnerDetailsPage />,
                },
              ]
            : []),
          ...(contests_BadgeRewardsPermission
            ? [
                {
                  path: '/Contests/JJBadges',
                  element: <JJBadgesPage />,
                },
                {
                  path: '/Contests/JJBadges/New',
                  element: <JJBadgesNewPage />,
                },
                {
                  path: '/Contests/JJBadges/:id',
                  element: <JJBadgesDetailPage />,
                },
              ]
            : []),
          ...(contests_LocationsBadgeRewardsPermission
            ? [
                {
                  path: '/Contests/LocationBadges',
                  element: <LocationBadgesPage />,
                },
                {
                  path: '/Contests/LocationBadges/New',
                  element: <LocationBadgesNewPage />,
                },
                {
                  path: '/Contests/LocationBadges/:id',
                  element: <LocationBadgesDetailPage />,
                },
              ]
            : []),
        ]
      : []),

    ...(promotionsPermission && specialsAndEventsFeatureAllowed
      ? [
          {
            path: '/Promotions',
            element: <PromotionsPage />,
          },
          {
            path: '/Promotions/:id',
            element: <PromotionDetailsPage />,
          },
          {
            path: '/Promotions/New',
            element: <PromotionsNewPage />,
          },
        ]
      : []),

    ...(communicationsPermission &&
    communicationsPushNotificationsFeatureAllowed
      ? [
          ...(communications_MessagesPermission
            ? [
                {
                  path: '/Communications/Messages',
                  element: <MessagesPage />,
                },
                {
                  path: '/Communications/Messages/:id',
                  element: <CommunicationDetailsPage />,
                },
                {
                  path: '/Communications/Message/New',
                  element: <CommunicationsMessageNewPage />,
                },
              ]
            : []),
          ...(communications_BannersPermission &&
          communicationsBannerMessagesFeatureAllowed
            ? [
                {
                  path: '/Communications/Banners',
                  element: <BannersPage />,
                },
                {
                  path: '/Communications/Banners/:id',
                  element: <BannerDetailsPage />,
                },
                {
                  path: '/Communications/SystemBanner/New',
                  element: <CommunicationsSystemBannerNewPage />,
                },
              ]
            : []),
        ]
      : []),

    ...(settingsPermission && routeAllowed
      ? [
          {
            path: '/Settings/EULA',
            element: <SettingsDetailsPageEULA />,
          },
          {
            path: '/Settings/PatronApp',
            element: <SettingsDetailsPatronApp />,
          },
          {
            path: '/Settings/Celebrations',
            element: <SettingsDetailsCelebrations />,
          },
        ]
      : []),

    ...(jjUpdatesPermission && routeAllowed
      ? [
          {
            path: '/JJUpdates/',
            element: <JJUpdatesPage />,
          },
          {
            path: '/JJUpdates/Newsletters/New',
            element: <NewslettersNewPage />,
          },
          {
            path: '/JJUpdates/Newsletters/:id',
            element: <NewslettersDetailsPage />,
          },
          {
            path: '/JJUpdates/Resources',
            element: <JJResourcesPage />,
          },
          {
            path: '/JJUpdates/Resources/New',
            element: <ResourcesNewPage />,
          },
          {
            path: '/JJUpdates/Resources/:id',
            element: <ResourcesDetailsPage />,
          },
        ]
      : []),
  ]

  return routesProtected.map((route) => (
    <Route path={route.path} key={route.path} element={route.element} />
  ))
}
